import { UPDATE_MEDIA_PLAN_DRAFT } from "@gql/mmm-media-plan";
import { useNorthbeamMutation } from "@hooks/http";
import {
  type UpdateMediaPlanDraft,
  type UpdateMediaPlanDraftVariables,
} from "@north-beam/nb-client-side/nb-api-graphql-generated";

import { useMediaPlanData } from "./use-media-plan";

export const useUpdateMediaPlan = () => {
  const { setMediaPlanList } = useMediaPlanData();
  const [updateMediaPlan, { loading: isUpdateMediaPlanLoading }] =
    useNorthbeamMutation<UpdateMediaPlanDraft, UpdateMediaPlanDraftVariables>(
      UPDATE_MEDIA_PLAN_DRAFT,
      {
        update: (_cache, { data }) => {
          if (data) {
            setMediaPlanList((prevMediaPlanList) => {
              if (data.updateMediaPlanDraft.id) {
                return prevMediaPlanList.map((mediaPlan) => {
                  if (mediaPlan.id === data.updateMediaPlanDraft.id) {
                    return data.updateMediaPlanDraft;
                  }
                  return mediaPlan;
                });
              }
              return prevMediaPlanList;
            });
          }
        },
      },
    );

  return { updateMediaPlan, isUpdateMediaPlanLoading };
};
